/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Adjust_DeltaInputs */

const vi_customer_debt_adjust_delta = /** @type {(inputs: Customer_Debt_Adjust_DeltaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thay đổi`)
};

/**

* @param {Customer_Debt_Adjust_DeltaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_adjust_delta = /** @type {((inputs?: Customer_Debt_Adjust_DeltaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Adjust_DeltaInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_adjust_delta(inputs)
});